var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gs-shop-category-item"},[_vm._v(" TODO: Shop category item ")])}
var staticRenderFns = []

export { render, staticRenderFns }